import React, {type ReactNode} from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';
const StyledContainerDiv = styled.div`
  > .collapsible-title {
    border-bottom: 1px solid ${colors.borderGray};

    > h5.collapsible-title-text {
      font-size: 1.05em;
    }

    > .collapsible-title-text {
      .clickable {
        border: none;
        background: none;

        &:focus {
          outline: none;
        }
      }

      .icon {
        transition: all 0.1s ease-in-out;
      }

      &.collapsed .icon {
        transform: rotate(-90deg);
      }
    }
  }

  > .collapsible-content {
    margin-left: 2rem;
  }
`;
type Props = {
  title: ReactNode;
  additionalTitle?: ReactNode;
  sub?: boolean;
  collapsed: boolean;
  onToggle: () => void;
  content: ReactNode;
  actions?: ReactNode;
};
export const CollapsibleSection = ({
  title,
  sub = false,
  collapsed,
  onToggle,
  additionalTitle,
  content,
  actions,
}: Props) => {
  const TagName = sub ? 'h5' : 'h4';
  return (
    <StyledContainerDiv>
      <div className="collapsible-title d-flex align-items-center justify-content-around">
        <TagName
          className={cs('collapsible-title-text flex-grow-1 pt-3 pb-2 mb-0', {
            collapsed,
            sub,
          })}
        >
          <button className="clickable" onClick={onToggle}>
            <i className="small icon fas fa-fw fa-chevron-down" /> {title}
            {additionalTitle != null ? (
              <small className="ml-3 text-muted">{additionalTitle}</small>
            ) : null}
          </button>
        </TagName>
        {actions != null ? actions : null}
      </div>
      <div className="collapsible-content" hidden={collapsed}>
        {content}
      </div>
    </StyledContainerDiv>
  );
};
